<template>
  <el-dialog
    title="订单详情"
    :visible="visible"
    width="760px"
    top="8vh"
    append-to-body
    :lock-scroll="false"
    :close-on-click-modal="true"
    custom-class="inorder-detail-dialog"
    @update:visible="updateVisible"
    @close="updateVisible(false)"
  >
    <div v-loading="loading" class="detail-body">
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane
          v-for="item in fields"
          :key="item.key"
          :label="item.label"
          :name="item.key"
        >
          <div class="detail-pane">
            <div class="detail-toolbar">
              <el-button size="mini" icon="el-icon-magic-stick" class="ele-btn-icon" @click="format(item.key)">
                美化
              </el-button>
              <el-button size="mini" icon="el-icon-document-copy" class="ele-btn-icon" @click="copy(detail[item.key])">
                复制
              </el-button>
            </div>
            <el-input
              type="textarea"
              readonly
              resize="none"
              :value="detail[item.key]"
              class="detail-textarea"
            />
            <div
              v-if="item.key === 'up_back_content' && detail.up_back_time"
              class="detail-sub-text"
            >
              回调时间：{{ detail.up_back_time }}
            </div>
            <div
              v-if="item.key === 'callback_remark' && detail.callback_remark_time"
              class="detail-sub-text"
            >
              发送时间：{{ detail.callback_remark_time }}
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
const FIELDS = [
  { key: 'request_json', label: '请求参数' },
  { key: 'up_jk_back', label: '上游响应' },
  { key: 'up_back_content', label: '上游回调' },
  { key: 'merchant_response', label: '原始响应' },
  { key: 'callback_remark', label: '回调信息' },
  { key: 'callback_content', label: '返回信息' }
];

function prettyJson(raw) {
  const text = raw == null ? '' : String(raw).trim();
  if (!text) return '';
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch (e) {
    return '';
  }
}

export default {
  props: {
    visible: Boolean,
    orderId: [Number, String],
    initialTab: {
      type: String,
      default: 'request_json'
    }
  },
  data() {
    return {
      loading: false,
      detail: {},
      fields: FIELDS,
      activeTab: this.initialTab || 'request_json'
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.loading = false;
        return;
      }
      this.activeTab = this.initialTab || 'request_json';
      this.load();
    },
    orderId(val) {
      if (this.visible && val) this.load();
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    load() {
      if (!this.orderId) return;
      this.loading = true;
      this.$http.post('/Inorder/detail', { id: this.orderId }).then((res) => {
        this.loading = false;
        if (res.data.code === 0) {
          this.detail = res.data.data || {};
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    format(key) {
      const pretty = prettyJson(this.detail[key]);
      if (!pretty) {
        this.$message.warning('当前内容无法格式化');
        return;
      }
      this.$set(this.detail, key, pretty);
    },
    copy(text) {
      const value = text == null ? '' : String(text).trim();
      if (!value) return;
      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.style.position = 'fixed';
      textarea.style.left = '-999999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (e) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(textarea);
    }
  }
};
</script>

<style scoped>
.detail-body {
  min-height: 360px;
}

.detail-pane {
  display: flex;
  flex-direction: column;
  height: calc(58vh - 120px);
  min-height: 280px;
}

.detail-toolbar {
  flex-shrink: 0;
  margin-bottom: 8px;
  text-align: right;
}

.detail-toolbar .el-button + .el-button {
  margin-left: 8px;
}

.detail-textarea {
  flex: 1;
  min-height: 0;
}

.detail-textarea ::v-deep .el-textarea {
  height: 100%;
}

.detail-textarea ::v-deep textarea {
  height: 100% !important;
  min-height: 240px;
  font-family: Consolas, 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  color: #303133;
  background: #fafafa;
}

.detail-sub-text {
  flex-shrink: 0;
  margin-top: 8px;
  padding: 8px 10px;
  font-size: 12px;
  color: #606266;
  line-height: 1.6;
  background: #f4f4f5;
  border-radius: 4px;
}
</style>

<style>
.inorder-detail-dialog .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 16px;
}

.inorder-detail-dialog .el-tabs--border-card {
  box-shadow: none;
  border-color: #e4e7ed;
}

.inorder-detail-dialog .el-tabs__content {
  padding: 12px;
}
</style>
